import { FC } from 'react';

type QuizProgressBarProps = {
  currentQuizStep: number;
  totalQuizSteps: number;
  isShowingLabel?: boolean;
};

const QuizProgressBar: FC<QuizProgressBarProps> = ({
  currentQuizStep,
  totalQuizSteps,
  isShowingLabel = false
}) => {
  const progressPercentage =
    totalQuizSteps <= 0
      ? 0
      : Math.round((currentQuizStep / totalQuizSteps) * 100);

  return (
    <div className="px-6 pt-8 pb-2">
      {isShowingLabel && (
        <p className="mb-3 font-body text-xs font-medium uppercase tracking-widest text-neutral-500">
          {currentQuizStep} / {totalQuizSteps}
        </p>
      )}
      <div className="h-1 w-full overflow-hidden rounded-full bg-neutral-300">
        <div
          className="h-full rounded-full transition-all duration-700 ease-out bg-primary-600"
          style={{
            width: `${progressPercentage}%`
          }}
        />
      </div>
    </div>
  );
};

export default QuizProgressBar;
